import { Server, contentClient } from '@wajeez-web/core/api-base';
import { thunkErrorHandler } from '@wajeez-web/core/utils';
import { ApiMethod } from '@wajeez-web/stores/base';

export const getLanguagesLookups: ApiMethod<
  void,
  Server.LanguageOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Languages_Client(
        undefined,
        contentClient
      );

      const response = await client.languages_get_V1();

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};
